import { Typography } from '@material-ui/core'
import React from 'react'

export const Dashboard: React.FC = () => {
  return (
    <Typography>Dashboard</Typography>
  )
}
